export const SET_EMAIL_SENDERS = 'SET_EMAIL_SENDERS';

export const SET_DEFAULT_EMAIL_TEMPLATE = 'SET_DEFAULT_EMAIL_TEMPLATE';
